import MBox from "@mui/material/Box";
import MMenu from "@mui/material/Menu";
import MMenuItem from "@mui/material/MenuItem";
import { styled } from "@mui/material/styles";
import { CSSProperties } from "@mui/styles";
import { colors } from "@zapalacorp/tokens";

export const Menu = styled(MMenu)(() => ({
  "& .MuiPaper-root": {
    minWidth: "224px",
    padding: "12px 0",
    borderRadius: "12px",
    background: colors.white,
    boxShadow: "0px 2px 6px 2px rgba(71, 84, 103, 0.15), 0px 1px 2px 0px rgba(71, 84, 103, 0.30)",
  },
  "& .MuiList-padding": {
    padding: 0,
  },
}));

export type MenuSizeProps = "medium" | "large";

type MenuItemProps = {
  isError?: boolean;
  size?: MenuSizeProps;
};

const MENU_ITEM_PADDING_CONFIG: Record<MenuSizeProps, CSSProperties["padding"]> = {
  medium: "8px 12px",
  large: "8px 16px",
};

const MENU_ITEM_FONT_CONFIG: Record<MenuSizeProps, CSSProperties> = {
  medium: {
    fontFamily: "Manrope, sans-serif",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "20px",
    letterSpacing: "0.25px",
  },
  large: {
    fontFamily: "Manrope, sans-serif",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "24px",
    letterSpacing: "0.5px",
  },
};

export const MenuItem = styled(MMenuItem, {
  shouldForwardProp: (props) => props !== "isError",
})<MenuItemProps>(({ isError, size }) => {
  const fontConfig = MENU_ITEM_FONT_CONFIG[size!] ?? MENU_ITEM_FONT_CONFIG.medium;
  const paddingConfig = MENU_ITEM_PADDING_CONFIG[size!] ?? MENU_ITEM_PADDING_CONFIG.medium;

  return {
    color: isError ? colors.error600 : colors.gray600,
    display: "flex",
    alignItems: "center",
    gap: "12px",

    ...fontConfig,

    "&.MuiMenuItem-root": {
      minHeight: "40px",
      padding: paddingConfig,
    },
  };
});

type MenuSubheaderProps = {
  isError?: boolean;
  size?: MenuSizeProps;
};

export const MenuSubheader = styled(MBox, {
  shouldForwardProp: (props) => props !== "isError",
})<MenuSubheaderProps>(({ isError, size }) => {
  const paddingConfig = MENU_ITEM_PADDING_CONFIG[size!] ?? MENU_ITEM_PADDING_CONFIG.medium;

  return {
    color: isError ? colors.error600 : colors.gray600,
    display: "flex",
    alignItems: "center",
    gap: "12px",
    padding: paddingConfig,
    fontFamily: "Manrope",
    fontSize: "12px",
    fontWeight: 600,
    lineHeight: "16px",
    letterSpacing: "0.5px",
  };
});

export const MenuItemText = styled("div")(() => ({
  fontFamily: "Manrope",
  fontSize: "14px",
  fontWeight: 400,
  lineHeight: "20px",
  letterSpacing: "0.25px",
  flex: 1,
}));
